import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=e0ff0042"
import script from "./ContactModal.vue?vue&type=script&lang=ts"
export * from "./ContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports